<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>협회 소개</p></li>
            <li><p>인사말</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>인사말</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="greeting">
            <div class="pattern type02"></div>
            <div class="pattern type03"></div>
            <div class="greeting_img">
              <div class="pattern type01"></div>
              <div class="thumb">
                <div class="inner">
                  <img
                    src="@/assets/static/images/img_president.png"
                    alt="한국외식산업협회 상임회장 윤홍근"
                  />
                </div>
              </div>
              <p>
                (사)한국외식산업협회<br />
                상임회장 윤 홍 근
              </p>
            </div>
            <div class="greeting_txt">
              외식산업은 비약적인 성장과 발전을 거듭하여, 매출규모 108조원,
              종사자수 200만 명의 거대산업이자 국가 경제의 당당한 한 축으로
              성장했으며, 향후 10년 이내에는 매출규모 150조원이 넘는
              종합문화산업으로서 대한민국 문화 수출의 핵심으로 성장해 나아갈,
              가장 역동적이고 미래지향적인 산업으로 확고히 자리매김하고
              있습니다.<br />
              <br />
              이제 우리 외식산업인들이 미래경제의 주역이자 핵심산업인으로
              대접받는 시대를 맞이하게 될 것입니다.<br />
              <br />
              (사)한국외식산업협회는 지난 2014년에 식품의약품안전처로 부터
              식품위생교육 전문기관으로 지정되었으며, 회원 권익 향상을 위해 각종
              사업 및 정부 용역을 수행 해온 결과 명실상부한 대표적인 자생적
              외식사업자 단체로 성장하였습니다.<br />
              <br />
              여기서 멈추지 않고 대한민국 외식산업을 책임지는 유일한 단체가 되기
              위해 앞으로도 노력하겠습니다. 외식산업인 여러분의 많은 관심과
              사랑을 부탁드립니다.
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'about-greeting-index',
  description: '인사말'
}
</script>

<style scoped></style>
